import { useState, useCallback } from 'react';
import { useOnce } from '../../../../../hooks';
import { getAccountStatus, EDIT_TYPES } from '../../../../../modules/provider/accountNotification';
import type { IAccountFieldEditStatus } from '../../../../../modules/Api.types';

export const DISMISSED_KEY = 'accountNotificationBannerDismissedId';

const useFraudBanner = (providerId: number | string) => {
  const [accountStatus, setAccountStatus] = useState<IAccountFieldEditStatus>({});
  const [shouldShow, setShouldShow] = useState<boolean|undefined>();

  useOnce(async () => {
    // Check whether to show Fraud banner first
    const status = await getAccountStatus(providerId);
    setAccountStatus(status);
    if (status.blocked && JSON.parse(
      localStorage.getItem(
        DISMISSED_KEY,
      ),
    ) !== status.id) {
      setShouldShow(true);
    } else {
      setShouldShow(false);
    }
  }, !!providerId || null);

  const editType = accountStatus?.last_changed_field ? EDIT_TYPES[
    accountStatus.last_changed_field
  ] : undefined;

  const onDismiss = useCallback(() => {
    localStorage.setItem(
      DISMISSED_KEY,
      JSON.stringify(accountStatus.id),
    );
    setShouldShow(false);
  }, [accountStatus.id]);

  return {
    accountStatus,
    editType,
    shouldShow,
    onDismiss,
  };
};

export default useFraudBanner;
